"use client";

import {
  PersonalData,
  PrintSettings,
  SettingsSkeleton,
} from "@/features/settings";
import {
  useInterimStateManager,
  useUserProfile,
} from "@/state/globalStore";
import WithDrawerOpen from "@/shared/ui/gestures/WithDrawerOpen";

export default function PrivateSettingsDrawers() {
  const { userProfile } = useUserProfile();
  const { interimState, setInterimState, resetInterimState } =
    useInterimStateManager();

  return (
    <>
      <WithDrawerOpen
        title="Personal Info"
        isOpen={interimState.edit_personal?.isOpen ?? false}
        onOpenChangeAction={(isOpen) => {
          setInterimState("edit_personal", { isOpen });
        }}
        onCloseAction={() => {
          resetInterimState("edit_personal");
        }}
      >
        {userProfile.isLoading ? <SettingsSkeleton /> : <PersonalData />}
      </WithDrawerOpen>

      <WithDrawerOpen
        title="Profile export settings"
        isOpen={interimState.edit_output_settings?.isOpen ?? false}
        onOpenChangeAction={(isOpen) => {
          setInterimState("edit_output_settings", { isOpen });
        }}
        onCloseAction={() => {
          resetInterimState("edit_output_settings");
        }}
      >
        <PrintSettings />
      </WithDrawerOpen>
    </>
  );
}
